@if (auth.isAuthenticated()) {
  <Menu [menuItems]="menuItems">
    <button type="button" class="user-pill" [title]="auth.userName()" data-testid="user-menu-trigger">
      <span class="user-pill__avatar" aria-hidden="true">{{ initials() }}</span>
      <span class="user-pill__name">{{ auth.userName() }}</span>
    </button>
  </Menu>
}
